import { useState } from 'react'
import { useVisibilityAwareInterval } from '../../../hooks/useVisibilityAwareInterval'
import { useNls } from '../../../nls/nlsProvider'
import { StatusChip } from '../../Common'

export const FreshnessChip = ({ lastSyncedAt }: { lastSyncedAt?: Date | null }) => {
  const { t } = useNls()
  const [now, setNow] = useState(Date.now())
  useVisibilityAwareInterval(() => setNow(Date.now()), 5000)
  if (!lastSyncedAt) return null
  const seconds = Math.max(0, Math.floor((now - lastSyncedAt.getTime()) / 1000))
  if (seconds < 60) return <StatusChip tone="success" size="sm">{t('NLSAnalysisFreshnessFreshSeconds', { seconds })}</StatusChip>
  const minutes = Math.floor(seconds / 60)
  return <StatusChip tone={minutes >= 5 ? 'warning' : 'success'} size="sm">{minutes >= 5 ? t('NLSAnalysisFreshnessStale', { minutes }) : t('NLSAnalysisFreshnessFreshMinutes', { minutes })}</StatusChip>
}
